export default ({ isAuthenticated, isRecognised }) => {
  if (isAuthenticated) return "logged in";
  if (isRecognised) return "recognized";

  return "anonymous";
};
